import { render, staticRenderFns } from "./ImageTrainingUpload.vue?vue&type=template&id=472eb062&scoped=true"
import script from "./ImageTrainingUpload.vue?vue&type=script&lang=js"
export * from "./ImageTrainingUpload.vue?vue&type=script&lang=js"
import style0 from "./ImageTrainingUpload.vue?vue&type=style&index=0&id=472eb062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472eb062",
  null
  
)

export default component.exports